import { Select, styled } from "@mui/material";

export const CustomSelect = styled(Select)(() => ({
  '&.MuiOutlinedInput-root': {
    borderRadius: '8px',
    paddingRight: '8px',
    '& fieldset': {
      borderColor: '#054254 !important',
    },
    '&:hover fieldset': {
      borderColor: '#054254 !important',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#054254 !important',
    },
    '& .MuiSelect-icon': {
      top: '50%',
      transform: 'translateY(-50%)',
      right: '8px',
    },
  },
}));